import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "form-custom mt-2" }
const _hoisted_2 = {
  key: 0,
  class: "text-gray text-center warning-label m-auto mt-lg-5"
}
const _hoisted_3 = { class: "mt-5" }
const _hoisted_4 = { class: "p-field-label mt-3" }
const _hoisted_5 = { class: "list-unstyled" }
const _hoisted_6 = { class: "mt-3 d-flex align-items-center" }
const _hoisted_7 = { class: "px-2 warning-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KeypadCodeInput = _resolveComponent("KeypadCodeInput")
  const _component_InlineSvgScoped = _resolveComponent("InlineSvgScoped")
  const _component_ElScrollbar = _resolveComponent("ElScrollbar")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_ElScrollbar, { class: "details-panel-content-wrapper" }, {
      default: _withCtx(() => [
        (_ctx.plantHasPasspartout)
          ? (_openBlock(), _createBlock("div", _hoisted_2, _toDisplayString(_ctx.$t("AppResourceEP.KeypadCodeDisabledMessage")), 1))
          : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
              (_ctx.loadInput)
                ? (_openBlock(), _createBlock(_component_KeypadCodeInput, {
                    key: _ctx.updateApartKey,
                    modelValue: _ctx.keypadCode,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.keypadCode = $event)),
                    alreadyUsedCodes: _ctx.alreadyUsedCodes,
                    label: _ctx.$t('AppResourceEP.KeypadCodePlaceHolder'),
                    keypadCodeRequiredLength: _ctx.currentEntrancePlant.keypadCodeRequiredLength,
                    disabled: _ctx.disabled,
                    onErrorKeyCode: _ctx.handleErrorKeyCode,
                    onKeyCodeEdited: _ctx.handleKeypadCodeEdited
                  }, null, 8, ["modelValue", "alreadyUsedCodes", "label", "keypadCodeRequiredLength", "disabled", "onErrorKeyCode", "onKeyCodeEdited"]))
                : _createCommentVNode("", true),
              _createVNode("div", _hoisted_3, [
                _createVNode("label", _hoisted_4, _toDisplayString(_ctx.$t("AppResourceEP.AccessCodeInstruction")), 1),
                _createVNode("ul", _hoisted_5, [
                  _createVNode("li", null, _toDisplayString(_ctx.$t("AppResourceEP.AccessCodeInstruction_Lenght", [_ctx.currentEntrancePlant.keypadCodeRequiredLength])), 1),
                  _createVNode("li", null, _toDisplayString(_ctx.$t("AppResourceEP.AccessCodeInstruction_Different")), 1),
                  _createVNode("li", null, _toDisplayString(_ctx.$t("AppResourceEP.AccessCodeInstruction_Consecutive")), 1),
                  _createVNode("li", null, _toDisplayString(_ctx.$t("AppResourceEP.AccessCodeInstruction_SameNumber")), 1)
                ])
              ]),
              _createVNode("div", _hoisted_6, [
                _createVNode(_component_InlineSvgScoped, {
                  class: "svg-icon-alert",
                  src: require(`@/assets/images/icons/icon-alert-medium-outline.svg`),
                  "aria-label": "icon-alert"
                }, null, 8, ["src"]),
                _createVNode("label", _hoisted_7, _toDisplayString(_ctx.$t("AppResourceEP.ChangeAccessCodeLengthInfo")), 1)
              ])
            ], 64))
      ]),
      _: 1
    })
  ]))
}